import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PlayBlocksIntegrationsIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#7985a3' : this.getColor()
        return [
            <g transform="translate(0.75 0.75)">
                <circle cx="1.798" cy="1.798" r="1.798" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="11.989" transform="translate(3.597 1.798)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <circle cx="1.798" cy="1.798" r="1.798" transform="translate(5.994 5.994)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="5.994" transform="translate(0 7.793)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x2="5.994" transform="translate(9.591 7.793)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" stroke-width="1.5"/>
                <circle cx="1.798" cy="1.798" r="1.798" transform="translate(11.989 11.989)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <line x1="11.989" transform="translate(0 13.787)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 17.085 17.085'
}
